import { useState, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import { ContextualMenu, IContextualMenuItem, IconButton } from "@fluentui/react";

interface Props {
  supportUrl: string;
  termsUrl: string;
}

export const NavMenu = ({ supportUrl, termsUrl }: Props) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const navigate = useNavigate();

  const menuItems: IContextualMenuItem[] = [
    {
      key: "chat",
      text: "Chat",
      iconProps: { iconName: "Chat" },
      onClick: () => navigate("/Chat"),
    },
    {
      key: "content",
      text: "Manage Content",
      iconProps: { iconName: "BulkUpload" },
      onClick: () => navigate("/Content"),
    },
    {
      key: "terms",
      text: "Terms of Use",
      iconProps: { iconName: "TextDocument" },
      onClick: () => window.open(termsUrl, "_blank", "noopener,noreferrer"),
    },
    {
      key: "faq",
      text: "FAQ",
      iconProps: { iconName: "SurveyQuestions" },
      onClick: () => navigate("/FAQ"),
    },
    {
      key: "reportIssue",
      text: "Report an Issue",
      iconProps: { iconName: "ReportWarning" },
      onClick: () => window.open(supportUrl, "_blank", "noopener,noreferrer"),
    },
  ];

  const toggleMenu = (event: MouseEvent<HTMLElement>) => {
    if (menuAnchor) {
      // If the menu is already open, close it
      closeMenu();
    } else {
      // If the menu is closed, open it
      openMenu(event);
    }
  };

  const openMenu = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  return (
    <>
      <IconButton
        iconProps={{ iconName: "GlobalNavButton" }}
        styles={{
          icon: {
            fontSize: "2rem",
          },
          rootHovered: {
            backgroundColor: 'none',
          },
        }}
        onClick={toggleMenu}
        ariaLabel="Toggle menu" />
      <ContextualMenu
        items={menuItems}
        hidden={!menuAnchor}
        target={menuAnchor}
        onDismiss={closeMenu}
      />
    </>
  );
};
